<form #form="ngForm" novalidate>
    <div class="row container-form-list mb-3">
        <div class="col-12">
            <div class="card">
                <div class="card-header">
                    <h6 class="card-title">Segmentos</h6>
                </div>
                <div class="table-responsive">
                    <table class="table table-striped table-hover table-bordered">
                        <thead>
                            <tr>
                                <th class="col-delete" *ngIf="canEdit"></th>
                                <th class="col-tipo-classificacao">Tipo</th>
                                <th class="col-classificacao">Segmento</th>
                                <th class="col-obrigatorio text-center" title="Se é obrigatório informar o segmento quando for utilizado este grupo de segmentos">Obrigatório?</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let entity of entities; let i = index">
                                <td class="col-delete" *ngIf="canEdit">
                                    <a class="btn btn-link btn-link-delete" (click)="delete(i)" title="Excluir segmento">
                                        <i class="far fa-trash-alt" aria-hidden="true"></i>
                                    </a>
                                </td>     
                                <td class="col-tipo-classificacao">
                                    <sgt-tipo-classificacao-select
                                        #tipoClassificacaoSelect
                                        [(ngModel)]="entity.idTipoClassificacao"
                                        (ngModelChange)="onChangeTipoClassificacao(entity)"
                                        [(tipoClassificacao)]="entity.tipoClassificacao"
                                        name="idTipoClassificacao_{{i}}"
                                        id="idTipoClassificacao_{{i}}"
                                        required="required"
                                        [disabled]="!canEdit"
                                        #tipoClassificacao="ngModel">
                                    </sgt-tipo-classificacao-select>
                                    <sgt-form-control-error
                                        *ngIf="tipoClassificacao.errors && tipoClassificacao.errors.required && tipoClassificacao.dirty"
                                        msgError="O tipo é obrigatório">
                                    </sgt-form-control-error>                                  
                                </td>
                                <td class="col-classificacao">
                                    <sgt-classificacao-select
                                        #classificacaoSelect
                                        [(ngModel)]="entity.idClassificacao"
                                        (ngModelChange)="onChangeClassificacao(entity)"
                                        [(classificacao)]="entity.classificacao"
                                        [tipoClassificacaoFilterRequired]="true"
                                        [idTipoClassificacao]="entity.idTipoClassificacao"
                                        [nomeTipoClassificacao]="entity.tipoClassificacao?.nome"
                                        name="idClassificacao_{{i}}"
                                        id="idClassificacao_{{i}}"
                                        [disabled]="!canEdit"
                                        #classificacao="ngModel">
                                    </sgt-classificacao-select>
                                </td>
                                <td class="col-obrigatorio text-center">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.obrigatorio" name="obrigatorio_{{i}}" id="obrigatorio_{{i}}"
                                            [disabled]="config?.forceObrigatorio || entity.idClassificacao > 0" [readonly]="config?.forceObrigatorio || entity.idClassificacao > 0">
                                        <label class="custom-control-label" for="obrigatorio_{{i}}"></label>
                                    </div> 
                                </td>
                            </tr>
                            <tr *ngIf="entities?.length === 0" class="no-record">
                                <td class="text-center" colspan="4">
                                    <i class='fas fa-info' aria-hidden='true'></i> Nenhum segmento adicionado
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer" *ngIf="canEdit">
                    <button type="button" class="btn btn-primary btn-sm mr-2" (click)="insert()">
                        <i class="fas fa-plus" aria-hidden="true"></i> Adicionar segmento
                    </button>
                </div>
            </div>
        </div>
    </div>    
</form>